import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";

export default function MmeLinkDataTable({ mmeLinks = [], onEditLink }: any) {
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [page, setPage] = React.useState(0);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <TableContainer sx={{ height: 412 }} className="custom-scrollbar-css">
          <Table aria-label="simple table">
            <TableHead sx={{ backgroundColor: "#e6e3e3" }}>
              <TableRow>
                <TableCell sx={{ width: "200px", p: 1 }}>Topic Name</TableCell>
                <TableCell sx={{ width: "450px", p: 1 }}> Link URL</TableCell>
                <TableCell sx={{ width: "100px", p: 1 }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mmeLinks
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row: any, index: any) => (
                  <TableRow key={index}>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        width: "200px",
                        cursor: "pointer",
                        textTransform: "capitalize",
                      }}>
                      {row.payload}
                    </TableCell>
                    <TableCell sx={{ width: "450px" }}>{row.mmeLink}</TableCell>
                    <TableCell sx={{ width: "100px" }}>
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: "12px",
                        }}
                        onClick={() => onEditLink(row)}
                        disabled={
                          row.rnTopicStatus === "active" ? true : false
                        }>
                        {row.rnTopicStatus === "active"
                          ? "Registered"
                          : "Register"}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={mmeLinks.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </>
  );
}
